import React from "react";
import { Link } from "gatsby";
import Icon, { IconName } from "../icon";
var BookmarksLink = function BookmarksLink() {
    return /*#__PURE__*/ React.createElement(Link, {
        to: "/lesezeichen",
        className: "inline-block ml-2 z-20"
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.BOOKMARK,
        className: "text-makroOrange w-6 lg:w-8",
        tooltip: "Gesetzte Lesezeichen",
        color: "current-color"
    }));
};
export default BookmarksLink;
